module.exports = __webpack_public_path__ + "assets/21230e038cdeea8ff999e9a64a67064a.mp4";